<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="12">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.searchKey"
              :placeholder="
                $l('form_label_search_description_value') ||
                  '大类名称/大类编码搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  searchKey: '',
  scmCategoryStatusList: ['Y']
}

export default {
  data() {
    return {
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    }
  }
}
</script>
